import React from "react"
import './Head.css'

function Head() {
    return (
<div className='header'>
    <div className='head'>
        <div className="thak">
  <h1>THAAYÚ </h1>
    <span >
        Íno ní njano ya <strong> GÍKÛYÚ</strong>.
    </span>
    </div>
    
    </div>
    
</div>        

    )
}

export default Head